import { z } from '@harvestiq/zod';
import {
  CampaignCoverageTier,
  RmaLgmCommodityCodes,
  RmaLgmTypeCodes,
} from '@harvestiq/constants';
import { zCalendarDate, zDecimalNullable } from '@harvestiq/zod';

export const downloadLgmQuoteRequestSchema = z.object({
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  numberOfHead: z.coerce.number(),
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate().nullable().optional(),
  deductibles: z.array(z.coerce.number().int().min(0).max(150)).optional(),
  liveCattleTargetCwtPerHead: zDecimalNullable().optional(),
  feederCattleTargetCwtPerHead: zDecimalNullable().optional(),
  cornTargetBuPerHead: zDecimalNullable().optional(),
  coverageTier: z.nativeEnum(CampaignCoverageTier).nullable().optional(),
});

export type DownloadLgmQuoteRequest = z.input<
  typeof downloadLgmQuoteRequestSchema
>;
